module.exports = {"en":{"modules":{"specialoffer":{"title":"Special Offers"}}}}